import React from 'react';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import { SearchAllContent } from '../../components';
import { APP_OPTIONS } from '../../config/constants';
import { createQueryUrl } from '../../helpers/search';

const SearchMinimal = () => (
  <Container>
    <SearchAllContent routing={false} onlyFetchWithQuery>
      <div className="row">
        <div className="col-12 mb-8 mb-lg-12">
          <SearchAllContent.SearchBar
            onSubmit={(query: string) => {
              const url = createQueryUrl(
                APP_OPTIONS.parameters.searchPath,
                APP_OPTIONS.parameters.searchkitIndexAllContent,
                query,
              );
              window.location.href = url;
            }}
          />
        </div>
      </div>
    </SearchAllContent>
  </Container>
);

export default SearchMinimal;
